import { SideNav } from '@neo.tax/shared';

import { useAscNavSections } from './hooks';

export const AscSideNav = (): React.ReactElement => {
  const sections = useAscNavSections();
  return <SideNav sections={sections} variant="dark" gap={4} />;
};
